var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOffSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0097 1.97985C13.3703 1.51318 13.038 0.841461 12.4511 0.841461H3.84607L9.48142 6.47682L13.0097 1.97985Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00404 0L0 0.99697L6.08788 7.20505V11.4475C6.08788 11.8364 6.40606 12.1545 6.79495 12.1545H8.20909C8.59798 12.1545 8.91616 11.8364 8.91616 11.4475V9.91313L13.003 14L14 13.003L1.00404 0Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOffSm);
export default __webpack_public_path__ + "static/media/filter-off-sm.0268ef5b10a5e756c0e64841d297961f.svg";
export { ForwardRef as ReactComponent };